import { Icon } from '../ui/Icon';
import logo from '../../assets/logo.png';
import whatsappQr from '../../assets/whatsapp_qr.png';
import { sectorsData } from '../../data/sectors';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gray-950 text-gray-400 pt-16 pb-8 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-12 gap-8 md:gap-12 mb-12">
          <div className="md:col-span-4">
            <div className="flex items-center gap-2 mb-4">
              <img src={logo} alt="EasyBuy General Trading" className="h-10 w-auto" />
            </div>
            <p className="text-sm mb-6 leading-relaxed">
              EasyBuy is your premier partner for global procurement with
              supply chain excellence. We make importing easier for businesses
              worldwide.
            </p>
            <div className="flex gap-3">
              <button className="w-9 h-9 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-gray-700">
                <Icon name="linkedin" className="w-4 h-4" aria-label="LinkedIn" />
              </button>
              <button className="w-9 h-9 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-gray-700">
                <Icon name="youtube" className="w-4 h-4" aria-label="YouTube" />
              </button>
              <button className="w-9 h-9 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-gray-700">
                <Icon name="twitter" className="w-4 h-4" aria-label="Twitter" />
              </button>
            </div>
          </div>

          <div className="md:col-span-2">
            <h3 className="text-white font-semibold mb-4 text-sm">Explore</h3>
            <ul className="space-y-3 text-sm">
              <li>
                <Link to="/" className="hover:text-white transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="hover:text-white transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/coffee" className="hover:text-white transition-colors">
                  Coffee
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-white transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <h3 className="text-white font-semibold mb-4 text-sm">Services</h3>
            <ul className="space-y-3 text-sm">
              {Object.values(sectorsData).map((sector) => (
                <li key={sector.id}>
                  <Link to={`/sectors/${sector.id}`} className="hover:text-white transition-colors">
                    {sector.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h3 className="text-white font-semibold mb-4 text-sm">Contact</h3>
            <div className="bg-gray-900 rounded-2xl p-6 border border-gray-800">
              <div className="flex items-start gap-4 mb-4">
                <div className="w-12 h-12 bg-green-500/10 rounded-xl flex items-center justify-center shrink-0">
                  <Icon name="message-circle" className="w-6 h-6 text-green-500" aria-hidden="true" />
                </div>
                <div>
                  <div className="text-white font-medium mb-1">
                    Let's connect in WhatsApp
                  </div>
                  <p className="text-sm text-gray-500">Scan to chat with us</p>
                </div>
              </div>
              <img
                src={whatsappQr}
                alt="WhatsApp QR Code"
                className="w-32 h-32 rounded-lg bg-white p-2 mx-auto"
              />
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center gap-4 text-sm">
          <p>© 2025 EasyBuy. EasyBuy General Trading. All Rights Reserved.</p>
          <div className="flex gap-6">
            <a href="#" className="hover:text-white transition-colors">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
